import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FilterConfig, FiltersService } from 'src/app/filters/filters.service';
import { ServiceBase } from './service-base.service';
import { DefaultsService } from './defaults.service';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class MetricsService extends ServiceBase {
  constructor(
    public translateService: TranslateService,
    protected filtersService: FiltersService,
    protected defaultsService: DefaultsService,
    protected authenticationService: AuthenticationService
  ) {
    super(translateService);
  }

  getMetricsPostBody = (
    customerIds?: Array<number>,
    branchIds?: Array<number>,
    regionIds?: Array<number>,
    districtIds?: Array<number>
  ): any => {
    const filters: Array<any> = [];

    const userInfoView = this.authenticationService.userInfoView;
    const client =
      userInfoView && userInfoView.SelectedClient
        ? userInfoView.SelectedClient
        : null;
    if (!client) {
      throw new Error('SelectedClient is not initialized in userInfoView.');
    }

    if (customerIds && customerIds.length) {
      filters.push({ in: [{ var: 'customer_id' }, customerIds] });
    }

    if (branchIds && branchIds.length) {
      filters.push({ in: [{ var: 'client_branch_id' }, branchIds] });
      // Branches are the most specific geo level — skip district/region filters
      // to avoid ANDing contradictory IN lists when saved selections are stale.
    } else {
      if (districtIds && districtIds.length) {
        filters.push({ in: [{ var: 'client_district_id' }, districtIds] });
      }

      if (regionIds && regionIds.length) {
        filters.push({ in: [{ var: 'client_region_id' }, regionIds] });
      }
    }

    const body: any = {
      filters: { and: [] },
      // Adding the clientId explicitly to make multi client functionality more transparent
      ClientCode: client?.ClientCode ?? null,
    };
    body.filters.and = filters;

    return this.applyFilters(body);
  };

  protected applyFilters(body: any): any {
    const appliedFilters = this.filtersService.form?.value;
    if (appliedFilters) {
      body.user_filters = [];
      Object.keys(appliedFilters).forEach((key) => {
        const filter: FilterConfig = this.filtersService.getFilter(key);
        const defaultValue = this.defaultsService.getFilterDefault(key);
        let appliedFilterValue = appliedFilters[key];
        if (defaultValue !== appliedFilterValue) {
          if (filter.hooks?.beforeSubmit) {
            appliedFilterValue = filter.hooks?.beforeSubmit(appliedFilterValue);
          }
          body.user_filters.push({
            name: filter.apiProperty,
            value: appliedFilterValue,
          });
        }
      });
    }
    return body;
  }
}
